webpackJsonp([58394153019023],{

/***/ 3724:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/australia.8fcee661.svg";

/***/ }),

/***/ 3725:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bg.6356d8b5.svg";

/***/ }),

/***/ 3729:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDhweCIgaGVpZ2h0PSI0MXB4IiB2aWV3Qm94PSIwIDAgNDggNDEiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ5LjIgKDUxMTYwKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IjE2LXBvbGljeS1hbmQtc2VydmljZS1kZXZlbG9wbWVudCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IjE2LXNlcnZpY2UtcGxhbnMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMzcuMDAwMDAwLCAtMzgwLjAwMDAwMCkiIGZpbGw9IiNGMjZDMjIiPgogICAgICAgICAgICA8ZyBpZD0iaW1wb3J0YW50LXNlY3Rpb24tIzEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDAwMDAwLCAzMTYuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0icG9saWN5LW5zdyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTM3LjAwMDAwMCwgNjAuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9Im5zdyI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik00MC4zMzYzNzMxLDcuODcxMzQyMzcgQzQwLjk1MDE1LDcuNjYyOTU4MyA0MS40OTg4MDY4LDcuMjc0MDUxNjMgNDIuMTY0MTAyNiw3LjIwOTE3ODkgQzQyLjI2MjAyOTksNy4xOTk2OTk0MSA0Mi4zMDI5OTc4LDcuMTM2MDYzMTMgNDIuMzQwODMzNCw3LjA2MTg3NTc3IEM0Mi4zNzE3NDQ4LDcuMDAxMTI0NTYgNDIuNDExOTcwOCw2Ljk0MzI1ODQxIDQyLjQzMTY3MTcsNi44NzkxMjc1NSBDNDIuNzAxNzEzNyw1Ljk5OTY3NzUzIDQzLjI2ODU4NzYsNS40NjIyMzEyOCA0NC4xOTcyNDg2LDUuMzM4MzM4MzcgQzQ0LjMxNjI3ODEsNS4yMzQwNjM5MSA0NC40NTk3MDcsNS4yODY4MTkzNyA0NC41OTA2MDY1LDUuMjg2MDc3NSBDNDUuNDkzNzE0LDUuMjgwNzE5NTIgNDYuMzk2ODIxNiw1LjI4MzI3NDg2IDQ3LjMwMDAxMTUsNS4yODMyNzQ4NiBDNDcuODI3NzMxLDUuMjgzMzU3MjkgNDcuODI3NzMxLDUuMjgzMzU3MjkgNDcuOTExNDgwMyw1Ljc1MzM3NTQ4IEM0Ny45MjgyOTYxLDYuMTc4MTM5MzcgNDcuOTQ2MTAxMSw2LjYwMjE2MTM4IDQ3Ljk4MjA0MDcsNy4wMjY3NjA0MSBDNDguMDY5MDg3Miw4LjA1Njk3NTY1IDQ3LjgzMDg2MzQsOS4wNTQzMDExNSA0Ny40NTg4NTQ5LDkuOTkzMDE4NjMgQzQ2LjU5NjIyMDcsMTIuMTY5OTIzMyA0NS42NzIwMTEsMTQuMzIyNjc1OCA0NC43NTQzMTMzLDE2LjQ3NzI0MTggQzQ0LjYyNTA2MjQsMTYuNzgwNzUwNSA0NC41ODMxODc3LDE3LjA5NTMwNSA0NC41ODE1MzkxLDE3LjM5NjUwNTcgQzQ0LjU3NzUsMTguMTMxNzg0OSA0NC4yNzM3NDQsMTguNzQ0OTAyMyA0My45Mzg0OTk1LDE5LjM2MzYyNDkgQzQzLjQ4ODI2NDYsMjAuMTk0Njg4MyA0My4wMzg4NTQxLDIxLjAyNzQ4MjcgNDIuNjI3OTM4NSwyMS44NzgyNDY5IEM0MS45Mzg1NzMsMjMuMzA1NDQ3IDQwLjkxNTY5NCwyNC40NDQyMjMxIDM5LjcwNjc2OTcsMjUuNDQ2MjQ3MSBDMzguODcxOTk3LDI2LjEzODE2OCAzOC4wNzY1NDM1LDI2Ljg3NzQwMzkgMzcuMjY2MDA1MywyNy41OTgyNTc4IEMzNy4xOTU4NTcsMjcuNjYwNzQgMzcuMTM0Nzc2MSwyNy43MzgxNDIyIDM3LjA4NTIzNTQsMjcuODE4MjY0NSBDMzYuMTQ5NzMyNywyOS4zMzM0MTc5IDM1LjE2Mzk0NzUsMzAuODIxMjg2NyAzNC41MTI2NjQ5LDMyLjQ5MjY0NTcgQzMzLjk0NzAyNzQsMzMuOTQ0MzI3NiAzMy4yMjEzOTI1LDM1LjMwNDQyOTMgMzIuMjI2NjIyNCwzNi41MTE3MDUgQzMyLjA2NzIwMiwzNi43MDUyNTE2IDMxLjk4MzM3MDIsMzYuOTMyMDE3NyAzMS45MDk2Nzc0LDM3LjE3MDczNjEgQzMxLjM4OTk1MzcsMzguODU2NzY3NyAzMC44NDY2NTQ5LDQwLjUzNTg3NTEgMzAuMzQyNzU3OCw0Mi4yMjY1MjI4IEMzMC4xNjc2NzU2LDQyLjgxNDA4NjcgMzAuMDY5MjUzNyw0My40MjYxMzI1IDI5Ljk2MjQyMzksNDQuMDMxNzQ4NyBDMjkuOTExNTY0NCw0NC4zMjA1MDI0IDI5LjgyMTc5NzcsNDQuMjk2MzUwMyAyOS42MjEyNDQ1LDQ0LjE1NzYxOTkgQzI3Ljk1MjI3Niw0My4wMDM1MTE4IDI2LjI4MjA3MTEsNDEuODUwOTY5OCAyNC42MDExNTAyLDQwLjcxNDMzNjkgQzI0LjM3NzEwNDQsNDAuNTYyNzQ3NCAyNC4zMzM5MTA4LDQwLjM1NTAyMjggMjQuMzM2NjMxLDQwLjE1Mjk4NTkgQzI0LjM1MjcwNSwzOC45ODM0NjMyIDIzLjcxNjAxMjUsMzguMDgxNzU3IDIzLjE0NzY1NDgsMzcuMTQ4NzI3MiBDMjMuMDg0ODQyOSwzNy4wNDU2ODkyIDIzLjAxNDk0MTksMzcuMDAxNjcxNCAyMi44OTAxNDIzLDM2Ljk4NzQxMDkgQzIxLjI0NDE3MTksMzYuNzk5ODgxNyAxOS41OTk3Njc3LDM2LjU5ODY2OTEgMTcuOTUzNDY3NiwzNi40MTM0NDggQzE3LjMzNDk5MjIsMzYuMzQzNzk0MyAxNi44MTk3MTk3LDM2LjAxNjEzMzQgMTYuMjcwNTY4NCwzNS43NzcyNTAxIEMxNS42NjE1NzI1LDM1LjUxMjMxODggMTUuMDExMzYxNSwzNS40MTM3MzIgMTQuMzgwMTA5NCwzNS4yMzkwNjIgQzE0LjI0MzAyNzYsMzUuMjAxMDYxNiAxNC4xNDEyMjYxLDM1LjI1MTgzODcgMTQuMDMyMzM1NSwzNS4zMTAyODE4IEMxMy44MjY5MTg5LDM1LjQyMDU3MzcgMTMuNjIxNDE5OSwzNS41MzA3ODMyIDEzLjQxNTA5NjYsMzUuNjM5NDI2NSBDMTIuNjUxMjE0LDM2LjA0MTg1MTcgMTEuOTY0MTU2NiwzNS45MDIwNDk3IDExLjU3NDY3MjksMzUuMTM3NDI1MyBDMTAuOTczMzQzMSwzMy45NTcwMjE4IDEwLjA2ODMzOTcsMzMuMDk3NTIgOC45NjQ1MTQwNiwzMi40MjY3MDEzIEM4LjE5MjMwNjAxLDMxLjk1NzM0MjYgNy41OTE4ODI5MiwzMS40MDUwNTg5IDcuNjM3Mzg0NSwzMC40MTAxMjM4IEM3LjYzOTc3NDk4LDMwLjM1ODQ0IDcuNTk0MDI2MTEsMzAuMzA1MTg5OSA3LjU5NDM1NTgzLDMwLjI1Mjg0NjYgQzcuNTk4MjMwMDYsMjkuNDEyNTUxIDYuODg4NTA0MjUsMjkuMjM2ODA5NCA2LjM0MjczMjUyLDI4LjkxNTE2NiBDNi4xNTkxNiwyOC44MDcwMTczIDYuMDQ0NzQ2NiwyOC45OTQxMzQzIDUuOTE3NTU2NDgsMjkuMDc3NTUzOSBDNS4yNjE5ODc0NSwyOS41MDc1MTA5IDUuMjYwODMzNDIsMjkuNTEyNTM5MSA0LjgwNjk3MTYsMjguODc3NDEyOCBDNC4yODA2NTM0NSwyOC4xNDExNDQ0IDMuNzU0NDE3NzIsMjcuNDA0NzExMiAzLjI0MTM3MDg3LDI2LjY1OTI5MyBDMy4wOTc5NDE5NiwyNi40NTA5MDg5IDIuOTUwODg2MTEsMjYuMzU1ODY2NyAyLjY3OTkzNzM2LDI2LjM0NTIzMzIgQzEuOTAwMTQ1NzEsMjYuMzE0NjUxNSAxLjEyMjQxNDgxLDI2LjIzMTgwODkgMC4zNDM2OTQ3NTIsMjYuMTcyMzc2NiBDMC4xMDM2NTc0MDUsMjYuMTUzOTk0NiAtMC4wMTU4NjY2ODU4LDI2LjA3MDgyMjMgMC4wMDE2OTA5OTEsMjUuNzkwNzIzOCBDMC4xMTY2ODE0MSwyMy45NTU0OTMyIDAuMjE4ODk1MTE1LDIyLjExOTYwMzIgMC4zMTc4MTE2MDQsMjAuMjgzMzgzNCBDMC4zODQyNTA1MTIsMTkuMDUwMDU5NyAwLjQzNDUzMzA2MSwxNy44MTU5MTE2IDAuNDk5MDc2MDcsMTYuNTgyNDIzIEMwLjU5OTQ3NjMwNiwxNC42NjQwMjAxIDAuNzA3ODcyMjkyLDEyLjc0NjExMTggMC44MDkwMTQ0MDIsMTAuODI3NzA4OSBDMC44NzQwNTE5OTQsOS41OTQyMjAzMiAwLjkyOTY5MjUxOSw4LjM2MDMxOTU1IDAuOTkzOTA1ODA3LDcuMTI2NzQ4NSBDMS4wNDM4NTg2Myw2LjE2NzUwNTg0IDEuMTA3NzQyMiw1LjIwODkyMjYzIDEuMTQ5Mjg3MTIsNC4yNDk0MzI2OSBDMS4xNTk0MjYwNiw0LjAxNTE2NTQ3IDEuMjU1NDU3NDksMy45ODU3Mzc4MiAxLjQ1NjE3NTUzLDQuMDA0Nzc5MjQgQzMuNDQ3NTI5MzIsNC4xOTI4ODU0MyA1LjQzODk2NTUzLDQuMzgwMDg0ODkgNy40MzEzOTA5MSw0LjU1NTQxNDM2IEM5LjE1MTA1NDA4LDQuNzA2ODM5MDIgMTAuODcyNjk1Niw0LjgzNTU5NTMyIDEyLjU5MjI3NjMsNC45ODc0MzIxMyBDMTQuNjExNzM4OSw1LjE2NTY0NjY3IDE2LjYyOTQ3MDQsNS4zNjM4OTE4IDE4LjY0OTAxNTQsNS41NDIzNTM2MyBDMjAuMzY4NzYwOSw1LjY5NDI3Mjg3IDIyLjA5MDMyLDUuODI1NTg0NTEgMjMuODEwMzk1Myw1Ljk3NDUzNjI2IEMyNS44OTkwMTcsNi4xNTU2MzU4NyAyNy45ODY5NzkyLDYuMzQ0MDcxNzggMzAuMDc0Nzc2Niw2LjUzNDMyMTE2IEMzMC4yNzQ3NTI3LDYuNTUyNTM4MjggMzAuNDQ3MzYyLDYuNTI1MzM2MjQgMzAuNjIwOTYwNSw2LjQxNTIwOTIyIEMzMC45OTA1Nzg0LDYuMTgwNjk0NzEgMzEuMzcxMzI0NSw1Ljk2MzczNzg4IDMxLjc0NzUzNjgsNS43Mzk2OTIwMyBDMzIuMTg2NDc4OCw1LjYzOTg2ODgxIDMyLjYzMTY4NTQsNS43MjQ4NTQ1NiAzMy4wNzI3NzA1LDUuNjk0MjcyODcgQzMzLjI0NTEzMjUsNS42ODIzMjA0NyAzMy40MjMyNjQ2LDUuNzM4MjA4MjggMzMuNTg5NjA5MSw1LjY1Mjg5MjgxIEMzNC4yNjQ3MTQyLDUuMzIwMjg2MTIgMzQuOTIyMDk2Nyw1LjQ3MzY4OTEgMzUuNTk0NDgxNSw1LjY4OTY1Njc3IEMzNi4yNjg1OTc0LDUuOTA2MTE5MDIgMzYuOTY2MDQxMSw2LjAzOTgyMTE0IDM3LjY3NDUzMDQsNi4wOTQyMjUyMSBDMzcuOTA0NTkzNyw2LjExMTg2NTMyIDM4LjAzMDM4MjUsNi4yMjI4OTkwOCAzOC4xMjc4OTc3LDYuNDMxMzY1NTggQzM4LjM1MzA5NzUsNi45MTM0MTg2IDM4LjYwNjE1ODksNy4zODI0NDc2MiAzOC44NDc5MjczLDcuODU2NzUyMTkgQzM5LjM0MzA4NjcsNy45Njg2OTI2OCAzOS44Mzk0ODI2LDcuOTQ2MjcxNjEgNDAuMzM2MzczMSw3Ljg3MTM0MjM3Ij48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.coordinatorsButtonStyle = exports.coordinatorsButtonSectionStyle = exports.roleSectionStyle = exports.subTitleStyle = exports.titleStyle = exports.cardSectionStyle = exports.contentSectionStyle = exports.innerWrapperStyle = exports.textStyle = exports.smallQuadrantsWrapperStyle = exports.quadrantsWrapperStyle = exports.quadrantsStyle = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _css, _css2, _divFirstChild, _css3;
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var quadrantsStyle = /*#__PURE__*/exports.quadrantsStyle = (0, _emotion.css)((_css = {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		alignItems: 'stretch',
		alignContent: 'stretch',
		position: 'relative',
		'& > *': {
			width: '50%',
			maxWidth: '458px',
			'& img': {
				display: 'block',
				marginBottom: '20px'
			},
			'& h1': (0, _emotion.cx)(_globalStyles.headingLarge, /*#__PURE__*/(0, _emotion.css)({
				marginBottom: '26px'
			})),
			'& p': (0, _emotion.cx)(_globalStyles.textBlock, /*#__PURE__*/(0, _emotion.css)({
				marginBottom: '40px'
			}))
		}
	}, _css['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		display: 'block',
		'& > section': {
			padding: '28px',
			width: '100%',
			maxWidth: 'initial'
		},
		'&:after': {
			display: 'none'
		}
	}, _css));
	
	var quadrantsWrapperStyle = exports.quadrantsWrapperStyle = (0, _emotion.cx)(quadrantsStyle, /*#__PURE__*/(0, _emotion.css)((_css2 = {
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		width: '100%',
		height: '100%',
		margin: '70px auto'
	}, _css2['@media (min-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		'& section:first-child': {
			marginRight: '15px',
			width: 'calc(50% - 15px)'
		},
		'& section:last-child': {
			marginLeft: '15px',
			width: 'calc(50% - 15px)'
		}
	}, _css2['@media (min-width: ' + _globalStyles.desktopMaxWidthBreakpoint + 'px)'] = {
		'& section': {
			margin: '0 !important',
			width: '50% !important'
		}
	}, _css2)));
	
	var smallQuadrantsWrapperStyle = exports.smallQuadrantsWrapperStyle = (0, _emotion.cx)(quadrantsStyle, /*#__PURE__*/(0, _emotion.css)({
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		width: '100%',
		height: '100%',
		'& img': {
			height: '27px'
		},
		'& h1': {
			fontSize: '18px',
			lineHeight: '18px'
		}
	}));
	
	var textStyle = exports.textStyle = (0, _emotion.cx)(_globalStyles.textBlock, /*#__PURE__*/(0, _emotion.css)({
		'& p': {
			maxWidth: '800px'
		}
	}));
	
	var innerWrapperStyle = /*#__PURE__*/exports.innerWrapperStyle = (0, _emotion.css)({
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		width: '100%',
		height: '100%',
		margin: '0 auto',
		padding: '0 20px'
	});
	
	var contentSectionStyle = exports.contentSectionStyle = _globalStyles.contentSection;
	
	var cardSectionStyle = exports.cardSectionStyle = function cardSectionStyle(margin) {
		return (0, _emotion.cx)((0, _globalStyles.cardSection)(margin), /*#__PURE__*/(0, _emotion.css)({
			'&#latest-updates': {
				'& header': {
					'& h1, & a': {
						color: '#fff'
					}
				}
			},
			'&#communication': {
				'& header': {
					'& h1': {
						color: _globalStyles.darkGrey
					},
					'& a': {
						color: _globalStyles.pink
					}
				}
			}
		}));
	};
	
	var titleStyle = exports.titleStyle = (0, _emotion.cx)(_globalStyles.headingLarge, /*#__PURE__*/(0, _emotion.css)({
		marginBottom: '31px'
	}));
	
	var subTitleStyle = exports.subTitleStyle = _globalStyles.headingMedium;
	
	var roleSectionStyle = /*#__PURE__*/exports.roleSectionStyle = (0, _emotion.css)((_css3 = {
		display: 'flex',
		justifyContent: 'space-between',
		'& > div:first-child': (_divFirstChild = {
			marginRight: '94px'
		}, _divFirstChild['@media (max-width: ' + _globalStyles.tabletLandscapeMaxWidthBreakpoint + 'px)'] = {
			marginRight: '44px'
		}, _divFirstChild['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
			marginRight: '0'
		}, _divFirstChild),
		'& [data-component=Card]': {
			width: '276px',
			height: '180px',
			flexShrink: '0'
		}
	
	}, _css3['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		flexDirection: 'column',
		justifyContent: 'flex-start'
	}, _css3));
	
	var coordinatorsButtonSectionStyle = /*#__PURE__*/exports.coordinatorsButtonSectionStyle = (0, _emotion.css)({
		margin: '40px 0'
	});
	
	var coordinatorsButtonStyle = /*#__PURE__*/exports.coordinatorsButtonStyle = (0, _emotion.css)(_extends({}, _globalStyles.museo900, {
		background: _globalStyles.pink,
		border: 'none',
		color: '#fff',
		fontSize: '18px',
		lineHeight: '15px',
		letterSpacing: '0.5',
		borderRadius: '4px',
		textTransform: 'uppercase',
		textDecoration: 'none',
		padding: '15px 17px 11px 17px'
	}));

/***/ }),

/***/ 1121:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _arrowLink = __webpack_require__(52);
	
	var _pageHeader = __webpack_require__(19);
	
	var _cards = __webpack_require__(17);
	
	var _policyCard = __webpack_require__(216);
	
	var _bg = __webpack_require__(3725);
	
	var _bg2 = _interopRequireDefault(_bg);
	
	var _nsw = __webpack_require__(3729);
	
	var _nsw2 = _interopRequireDefault(_nsw);
	
	var _australia = __webpack_require__(3724);
	
	var _australia2 = _interopRequireDefault(_australia);
	
	var _policyAndServiceDevelopment = __webpack_require__(265);
	
	var _globalStyles = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PolicyServiceDevelopmentPage = function (_React$PureComponent) {
		_inherits(PolicyServiceDevelopmentPage, _React$PureComponent);
	
		function PolicyServiceDevelopmentPage() {
			_classCallCheck(this, PolicyServiceDevelopmentPage);
	
			return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
		}
	
		PolicyServiceDevelopmentPage.prototype.render = function render() {
			var node = this.props.data.allContentJson.edges[0].node;
	
	
			return _react2.default.createElement(
				'div',
				{ className: _policyAndServiceDevelopment.wrapperStyle },
				_react2.default.createElement(
					_reactHelmet.Helmet,
					{ title: node.main_heading },
					_react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
					_react2.default.createElement('meta', { property: 'og:title', content: node.main_heading }),
					_react2.default.createElement('meta', { name: 'description', content: node.main_body }),
					_react2.default.createElement('meta', { property: 'og:description', content: node.main_body })
				),
				_react2.default.createElement(_pageHeader.PageHeader, {
					background: _globalStyles.pink + ' url(' + _bg2.default + ') no-repeat bottom right',
					titleText: node.main_heading,
					subTitleText: node.main_body,
					subTitleTextColor: '#fff',
					titleTextColor: '#fff'
				}),
				_react2.default.createElement(
					'div',
					{ className: _policyAndServiceDevelopment.innerWrapperStyle },
					_react2.default.createElement(
						'div',
						{ className: _policyAndServiceDevelopment.quadrantsWrapperStyle },
						_react2.default.createElement(
							'section',
							null,
							_react2.default.createElement('img', { src: _nsw2.default, alt: 'New South Wales' }),
							_react2.default.createElement(
								'h1',
								null,
								node.left_tile_heading
							),
							_react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: node.left_tile_body } }),
							_react2.default.createElement(
								_arrowLink.ArrowLink,
								{ to: node.left_tile_link_url },
								node.left_tile_link_text
							)
						),
						_react2.default.createElement(
							'section',
							null,
							_react2.default.createElement('img', { src: _australia2.default, alt: 'Australia' }),
							_react2.default.createElement(
								'h1',
								null,
								node.right_tile_heading
							),
							_react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: node.right_tile_body } }),
							_react2.default.createElement(
								_arrowLink.ArrowLink,
								{ to: node.right_tile_link_url },
								node.right_tile_link_text
							)
						)
					)
				),
				_react2.default.createElement(
					'section',
					{ className: (0, _policyAndServiceDevelopment.contentSectionStyle)() },
					_react2.default.createElement(
						'div',
						{ className: _policyAndServiceDevelopment.innerWrapperStyle },
						_react2.default.createElement(
							'header',
							null,
							_react2.default.createElement(
								'h1',
								{ className: _policyAndServiceDevelopment.titleStyle },
								node.subheading
							)
						),
						_react2.default.createElement('div', { className: _policyAndServiceDevelopment.textStyle, dangerouslySetInnerHTML: { __html: node.body } }),
						_react2.default.createElement(
							'div',
							{ className: (0, _policyAndServiceDevelopment.cardSectionStyle)() },
							_react2.default.createElement(
								_cards.Cards,
								{ columns: 4 },
								node.attachments.map(function (attachment, index) {
									return _react2.default.createElement(_policyCard.PolicyCard, { key: index, href: attachment.file, title: attachment.title });
								})
							)
						)
					)
				)
			);
		};
	
		return PolicyServiceDevelopmentPage;
	}(_react2.default.PureComponent);
	
	PolicyServiceDevelopmentPage.propTypes = {
		data: _propTypes2.default.shape({
			allContentJson: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: _propTypes2.default.shape({
						main_heading: _propTypes2.default.string.isRequired,
						main_body: _propTypes2.default.string.isRequired,
						left_tile_heading: _propTypes2.default.string.isRequired,
						left_tile_body: _propTypes2.default.string.isRequired,
						left_tile_link_text: _propTypes2.default.string.isRequired,
						left_tile_link_url: _propTypes2.default.string.isRequired,
						right_tile_heading: _propTypes2.default.string.isRequired,
						right_tile_body: _propTypes2.default.string.isRequired,
						right_tile_link_text: _propTypes2.default.string.isRequired,
						right_tile_link_url: _propTypes2.default.string.isRequired,
						subheading: _propTypes2.default.string.isRequired,
						body: _propTypes2.default.string.isRequired,
						attachments: _propTypes2.default.arrayOf(_propTypes2.default.shape({
							title: _propTypes2.default.string.isRequired,
							file: _propTypes2.default.string.isRequired
						})).isRequired
					})
				}))
			})
		})
	};
	exports.default = PolicyServiceDevelopmentPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-policy-and-service-development-index-js-6f318b3edc56c8a49780.js